import React from 'react';
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

const ContactSection = styled.section`
  padding: 5rem 1.6rem 4.5rem;
  text-align: left;
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
`;

const Title = styled.h1`
  font-size: 2.6rem;
  margin-bottom: 0.8rem;
  letter-spacing: -0.03em;
`;

const Message = styled.p`
  font-size: 1.1rem;
  margin-bottom: 1.8rem;
  max-width: 600px;
`;

const LinkList = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 2rem;
  flex-wrap: wrap;

  a {
    font-size: 1rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
`;

function Contact() {
  return (
    <ContactSection id="contact">
      <Title>Let’s Connect</Title>
      <Message>
        If you’ve got a project in mind or just want to say hi, feel free to reach out.
      </Message>
      <LinkList>
        <a href="mailto:sivaklukas@yahoo.com">sivaklukas@yahoo.com</a>
        <a href="https://github.com/lukaSt605n" target="_blank" rel="noreferrer">GitHub</a>
        <a href="https://www.linkedin.com/in/lukáš-sivak-b90a0319b/" target="_blank" rel="noreferrer">LinkedIn</a>
      </LinkList>
    </ContactSection>
  );
}

export default Contact;
